import { MpcSignDetail, TxRecordsModel } from '@/services/apis/history/model'
import React, { memo, useEffect, useState } from 'react'
import TxRecordApi from '@/services/apis/history/TxRecords'
import InfoNote from '../InfoNote'
import styles from './index.module.scss'
import { Table } from 'antd'
import { useTranslation } from '@/services/i18n'
const { Column } = Table
interface ChildPros {
  records: TxRecordsModel
}
const MpcExpandRow = memo<ChildPros>(props => {
  const { t } = useTranslation()
  const { records } = props
  const [list, setList] = useState<MpcSignDetail[]>([])
  const [id, setId] = useState('')
  const [loading, setLoading] = useState(false)

  async function getMpcDetail() {
    setLoading(true)
    const res = await TxRecordApi.getMpcDetail(records.txKey)
    setLoading(false)
    if (res.success) {
      setList(res.data as MpcSignDetail[])
    }
  }

  function renderInfo(_: any, detail: MpcSignDetail, index: number) {
    return <InfoNote records={detail} id={id} />
  }

  useEffect(() => {
    getMpcDetail()
  }, [])
  return (
    <div className={styles.container}>
      <Table
        dataSource={list}
        loading={loading}
        pagination={{ hideOnSinglePage: true }}
        size="small"
        onRow={(record: MpcSignDetail) => {
          return {
            onClick: event => {
              record.id && setId(record.id)
            },
          }
        }}
      >
        <Column title="Data" dataIndex="hash" className={styles.wordBreak} />
        <Column title={t('record.sign')} dataIndex="sig" className={styles.wordBreak} />

        <Column title={t('record.note')} render={renderInfo} />
      </Table>
    </div>
  )
})

export default MpcExpandRow
